import { LayoutComponent } from '../layout/layout.component';

import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { RecoverComponent } from './auth/recover/recover.component';
import { LockComponent } from './auth/lock/lock.component';
import { MaintenanceComponent } from './auth/maintenance/maintenance.component';
import { Error404Component } from './auth/error404/error404.component';
import { Error500Component } from './auth/error500/error500.component';


export const routes = [

    {
        path: '',
        component: LayoutComponent,
        children: [
           { path: '', redirectTo: '/login', pathMatch: 'full' },
            { path: 'home', loadChildren: './home/home.module#HomeModule' },
            { path: 'content', loadChildren: './content/content.module#ContentModule' },
            { path: 'category', loadChildren: './category/category.module#CategoryModule' },
            { path: 'applog', loadChildren: './applog/applog.module#AppLogModule' },
            { path: 'upload', loadChildren: './upload/upload.module#FormsModule' },
            { path: 'settings', loadChildren: './settings/settings.module#SettingModule' },
            { path: 'newsfeed', loadChildren: './newsfeed/newsfeed.module#NewsfeedModule' },
            { path: 'facility', loadChildren: './facility/facility.module#FacilityModule' },
            { path: 'blob', loadChildren: './blob/blob.module#BlobModule' },
            { path: 'user', loadChildren: './user/user.module#UserModule' },
            { path: 'tutorial', loadChildren: './tutorial/tutorial.module#TutorialModule' },
        ]
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'recover', component: RecoverComponent },
    { path: 'lock', component: LockComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },

    // Not found
    { path: '**', redirectTo: 'login' }

];



// WEBPACK FOOTER //
// ./src/app/routes/routes.ts